export type ComparableChartRow = Record<string, string | number | null | undefined>;

export function mergeIndexedPrevious<T extends object>(
  current: T[],
  previous: T[] | undefined,
  metrics: string[],
  compareEnabled: boolean,
): ComparableChartRow[] {
  return current.map((row, i) => {
    const previousRow = previous?.[i] as Record<string, unknown> | undefined;
    const merged: ComparableChartRow = { ...(row as ComparableChartRow) };
    for (const metric of metrics) {
      merged[`${metric}_prev`] = compareEnabled ? Number(previousRow?.[metric] ?? 0) : undefined;
      if (compareEnabled && previousRow?.[metric] == null) merged[`${metric}_prev`] = null;
    }
    return merged;
  });
}

export function mergeBucketedPrevious<T extends { bucket: string }>(
  current: T[],
  previous: T[] | undefined,
  metrics: string[],
  compareEnabled: boolean,
): ComparableChartRow[] {
  if (!compareEnabled) return current as ComparableChartRow[];
  const previousByBucket = new Map((previous ?? []).map((row) => [row.bucket, row]));
  return current.map((row) => {
    const prev = previousByBucket.get(row.bucket) as Record<string, unknown> | undefined;
    const merged: ComparableChartRow = { ...(row as ComparableChartRow) };
    for (const metric of metrics) {
      merged[`${metric}_prev`] = prev ? Number(prev[metric] ?? 0) : null;
    }
    return merged;
  });
}
